export default {
  metadata: {
    name: 'SwadeshFullWidthMedia'
  },
  hierarchy: {
    container: [
      'swadesh_media',
      {
        'inner-container': [
          {
            'content-container': ['swadesh_full_width_text-slot']
          },
          'content-slot'
        ]
      },
      {
        'media-control-container': ['media-control-slot']
      },
      {
        'play-overlay-container': [
          {
            'play-button-container': ['play-icon']
          }
        ]
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.stack}',
      width: '{size.max}',
      'aspect-ratio': 1
    },
    swadesh_media: {
      ratio: '100'
    },
    'inner-container': {
      size: '{size.max}',
      'z-index': 1,
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      'padding-bottom': '48'
    },
    'content-container': {
      size: '{size.max}',
      'padding-left': '{huge}',
      'padding-top': '{huge}',
      'padding-right': '{huge}'
    },
    'media-control-container': {
      'z-index': 2,
      size: '{size.max}',
      'justify-content': '{justifyContent.end}',
      'align-items': '{alignItems.end}',
      'padding-left': '44',
      'padding-top': '44',
      'padding-right': '44',
      'padding-bottom': '{xl}',
      gap: '{s}'
    },
    'play-overlay-container': {
      hidden: true,
      'z-index': 4,
      size: '{size.max}',
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.center}',
      'align-items': '{alignItems.center}'
    },
    'play-button-container': {
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.center}',
      'align-items': '{alignItems.center}',
      'background-color': '#1E1E1E33',
      'border-radius': '{pill}'
    },
    'play-icon': {
      value: 'ic_swadesh_play_outlined',
      size: '80',
      color: '{global.white}'
    }
  },
  variant: {
    showPlayButton: {
      true: {
        'play-overlay-container': {
          hidden: false
        }
      }
    },
    contentAlignment: {
      'bottom-center': {
        'content-container': {
          'justify-content': '{justifyContent.center}',
          'align-items': '{alignItems.end}'
        }
      },
      center: {
        'content-container': {
          'justify-content': '{justifyContent.center}',
          'align-items': '{alignItems.center}'
        }
      },
      'top-center': {
        'content-container': {
          'justify-content': '{justifyContent.center}',
          'align-items': '{alignItems.start}'
        }
      },
      'bottom-left': {
        'content-container': {
          'justify-content': '{justifyContent.start}',
          'align-items': '{alignItems.end}'
        }
      }
    },
    overlay: {
      true: {
        'inner-container': {
          'background-color': '#00000033'
        }
      }
    },
    ratio: {
      '75': {
        container: {
          'aspect-ratio': '{aspect_ratio.4.3}'
        },
        swadesh_media: {
          ratio: '75'
        }
      }
    }
  },
  api: {
    config: {
      showPlayButton: {
        values: [false, true]
      },
      contentAlignment: {
        values: [
          'top-left',
          'center',
          'bottom-center',
          'top-center',
          'bottom-left'
        ]
      },
      overlay: {
        values: [false, true]
      },
      ratio: {
        values: ['100', '75']
      }
    },
    data: {
      swadesh_media: {
        media: {
          type: 'slot',
          name: 'media'
        }
      }
    },
    children: {
      'content-slot': {
        name: 'children',
        accepts: ['any']
      },
      'swadesh_full_width_text-slot': {
        name: 'content',
        accepts: ['swadesh_full_width_text']
      },
      'media-control-slot': {
        name: 'controls',
        accepts: ['any']
      }
    }
  }
};
